import { Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const STORAGE_KEY = 'manarah-studio-lang';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly current = signal<'ar' | 'en'>(this.readStored());
  readonly language = this.current.asReadonly();

  constructor(private translate: TranslateService) {}

  setLanguage(lang: 'ar' | 'en'): void {
    this.current.set(lang);
    try { localStorage.setItem(STORAGE_KEY, lang); } catch { /* private mode */ }
    this.translate.use(lang);
    this.applyDirection();
  }

  applyDirection(): void {
    const dir = this.current() === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.body.dir = dir;
    document.documentElement.lang = this.current();
  }

  private readStored(): 'ar' | 'en' {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      return v === 'en' ? 'en' : 'ar';
    } catch {
      return 'ar';
    }
  }
}
